const ownerName = (owner: ICampaignOwnerDto | null): string | null => {
	if (!owner) return null
	return `${owner.first_name ?? ''} ${owner.last_name ?? ''}`.trim() || owner.email || null
}

export const Campaign = (json: ICampaign): ICampaignModel => ({
	id: json.id,
	name: json.name,
	businessDescription: json.business_description,
	department: json.department,
	distributionChannel: json.distribution_channel,
	workflowStatus: json.workflow_status,
	displayStatus: json.display_status,
	startsAt: json.starts_at ? new Date(json.starts_at) : null,
	endsAt: json.ends_at ? new Date(json.ends_at) : null,
	ownerId: json.owner_id,
	ownerName: ownerName(json.owner),
	requesterName: json.requester_name,
	requesterEmail: json.requester_email,
	approvedById: json.approved_by_id,
	approvedAt: json.approved_at ? new Date(json.approved_at) : null,
	codesSummary: json.codes_summary ?? { type: 'none' },
	createdAt: json.created_at ? new Date(json.created_at) : null,
	promotions: json.promotions ?? [],
})

export const CampaignListItem = (json: ICampaign): ICampaignListItemModel => ({
	id: json.id,
	name: json.name,
	codesSummary: json.codes_summary ?? { type: 'none' },
	displayStatus: json.display_status,
	workflowStatus: json.workflow_status,
	department: json.department,
	distributionChannel: json.distribution_channel,
	startsAt: json.starts_at ? new Date(json.starts_at) : null,
	endsAt: json.ends_at ? new Date(json.ends_at) : null,
	ownerId: json.owner_id,
	ownerName: ownerName(json.owner),
	requesterName: json.requester_name,
	createdAt: json.created_at ? new Date(json.created_at) : null,
})

// SCHEDULED to frontendowy status wyświetlania (backend = active + przyszły starts_at).
const resolveCampaignStatus = (status: ECampaignStatus | null): ECampaignStatus | undefined => {
	if (!status) return undefined
	if (status === ECampaignStatus.SCHEDULED) return ECampaignStatus.ACTIVE
	return status
}

export const CampaignCreatePayload = (data: ICampaignFormData): ICampaignCreatePayload => ({
	name: data.name,
	business_description: data.businessDescription || null,
	department: data.department,
	distribution_channel: data.distributionChannel,
	starts_at: data.startsAt ? data.startsAt.toISOString() : null,
	ends_at: data.endsAt ? data.endsAt.toISOString() : null,
	owner_id: data.ownerId,
	requester_name: data.requesterName || null,
	requester_email: data.requesterEmail || null,
	workflow_status: resolveCampaignStatus(data.workflowStatus),
})

export const CampaignUpdatePayload = (
	data: ICampaignFormData,
	statusChange?: { workflowStatus: ECampaignStatus; changeReason: string },
): ICampaignUpdatePayload => {
	const { workflow_status: _omit, ...base } = CampaignCreatePayload(data)
	return {
		...base,
		...(statusChange
			? { workflow_status: statusChange.workflowStatus, change_reason: statusChange.changeReason }
			: {}),
	}
}
